import { FE_ONLY } from '@/lib/flags';
import { authHeaders, clearToken } from '@/lib/auth';

export type Project = 'rag' | 'mark' | 'helper' | 'docs';
const API_BASE = {
  rag: process.env.NEXT_PUBLIC_API_RAG || '/api/rag',
  mark: process.env.NEXT_PUBLIC_API_MARK || '/api/mark',
  helper: process.env.NEXT_PUBLIC_API_HELPER || '/api/helper',
  docs: process.env.NEXT_PUBLIC_API_DOCS || '/api/autodocs_v3',
} as const;
const API_KEYS = { rag: 'NEXT_PUBLIC_API_RAG', mark: 'NEXT_PUBLIC_API_MARK', helper: 'NEXT_PUBLIC_API_HELPER', docs: 'NEXT_PUBLIC_API_DOCS' } as const;
function base(project: Project) {
  const url = (API_BASE as any)[project];
  if (!url) throw new Error(`Missing env ${(API_KEYS as any)[project]}`);
  return url;
}

export function apiClient(project: Project) {
  const prefix = base(project);
  return async function req<T>(path: string, init: RequestInit = {}) {
    if (FE_ONLY) {
      throw new Error('FE_ONLY');
    }
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...((init.headers as Record<string, string>) || {}),
      ...authHeaders(),
    };
    const res = await fetch(`${prefix}${path}`, { ...init, headers });
    if (res.status === 401) {
      clearToken();
      if (typeof window !== 'undefined') window.location.href = '/login';
    }
    if (!res.ok) {
      const t = await res.text().catch(() => '');
      throw new Error(`${project} ${res.status} ${path} ${t}`);
    }
    try { return (await res.json()) as T; } catch { return undefined as unknown as T; }
  };
}
